import { useQuery, QueryHookOptions } from '@apollo/client';

import managedSentinelTeamsQuery from './managedSentinelTeamsQuery.graphql';

export const useManagedSentinelTeamsQuery = (
  options: QueryHookOptions<
    ManagedSentinelTeamsQuery,
    ManagedSentinelTeamsQueryVariables
  >,
) => {
  return useQuery<
    ManagedSentinelTeamsQuery,
    ManagedSentinelTeamsQueryVariables
  >(managedSentinelTeamsQuery, options);
};
